import React from 'react';
import Select from 'react-select';
import {
  Card,
  CardBody,
  CardHeader
} from "../../../../_metronic/_partials/controls/Card";
import * as Api from "../../../General/api";
import DropdownValue from "./dropdownValue";
class Lookup extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      selectOptions: [],
      id: "",
      name: '',
      showResults: false
    }
  }
  async getOptions() {
    const res = await Api.getRequest(Api.Uri_GetDropdown)
    const data = res.data.result
    
    const options = data.map(d => ({
      "value": d.key,
      "label": d.value

    }))

    this.setState({ selectOptions: options })

  }

  handleChange(e) {
    this.setState({ id: e.value, name: e.label, showResults: true })
  }
  componentDidMount() {
    this.getOptions()
  }

  render() {
    return (
      <div >

        <Card className="example example-compact">
          <CardHeader title="Lookups" />
          <CardBody>
            <div className="col-sm-6 col-md-6 col-lg-6col-xl-6">
              <div className="form-group"><div role="alert" className="fade alert alert-primary show">Please select an option from following lookup to add/edit lookup values.</div>
                <Select options={this.state.selectOptions} onChange={this.handleChange.bind(this)} /></div></div>
          </CardBody>
        </Card>
        { this.state.showResults ? <DropdownValue headerID={this.state.id} /> : null}
      </div>
    );
  }

}

export default Lookup;  